import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * A typescript & react boilerplate with api call example
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as React from 'react';
import { Adapter, ComponentSync, LL_V_C, TS_Tree, } from '@nu-art/thunderstorm-frontend/index';
class Example_Tree_Data extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return { actionMessage: 'No action yet' };
    }
    elements = {
        dataTypes: {
            number: 42,
            string: 'a string',
            boolTrue: true,
            boolFalse: false,
            array_of_numbers: [0, 1, 2, 3, 4, 5],
            array_of_string: ['string1', 'string2', 'string3'],
            array_of_booleans: [true, true, false],
            _undefined: undefined,
            _null: null,
            object: {
                label: 'label',
                number: 500
            }
        }
    };
    render() {
        const adapter = new Adapter(this.elements).setTreeNodeRenderer(Example_ColorfulNodeRenderer);
        adapter.hideRoot = true;
        return _jsxs(LL_V_C, { style: { minWidth: 180 }, children: [_jsx(TS_Tree, { adapter: adapter, onNodeFocused: (path) => this.setState({ actionMessage: `on focused: ${path}` }), onNodeClicked: (path) => this.setState({ actionMessage: `on clicked: ${path}` }) }), _jsx("div", { className: "ts-playground__results", children: this.state.actionMessage })] });
    }
}
const ExpandCollapseComponentSVG = (props) => {
    const children = props.adapter.getFilteredChildren(props.item);
    let toDisplay;
    if (children.length === 0)
        toDisplay = '';
    else if (props.expanded)
        toDisplay = _jsx("svg", { width: "15", height: "15", viewBox: "0 0 15 15", fill: "currentColor", style: { color: '#9b59b6', verticalAlign: 'text-top' }, children: _jsx("path", { d: "M0 14l6-6-6-6z" }) });
    else
        toDisplay = _jsx("svg", { width: "15", height: "15", viewBox: "0 0 15 15", fill: "currentColor", style: { color: '#3498db', verticalAlign: 'text-top' }, children: _jsx("path", { d: "M0 5l6 6 6-6z" }) });
    return _jsx("div", { className: `clickable`, onClick: props.expandToggler, style: { width: '15px', marginRight: 2 }, children: toDisplay });
};
class Example_ColorfulNodeRenderer extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const valueStyle = (_value) => {
            switch (typeof _value) {
                case 'string':
                    return { color: '#e67e22' };
                case 'boolean':
                    return { color: '#bf95d0' };
                case 'number':
                    if (isNaN(_value))
                        return { color: '#e0e0e0' };
                    return { color: '#2ecc71' };
                case 'undefined':
                    return { color: '#000' };
                case 'object':
                    if (_value === null)
                        return { color: '#f1c40f' };
                // eslint-disable-next-line no-fallthrough
                default:
                    return { color: '#000000' };
            }
        };
        let value;
        const item = this.props.item;
        if (typeof item !== 'object')
            value = item;
        else if (Object.keys(item).length === 0)
            value = '{}';
        else
            value = '';
        const nameStyle = { color: '#000000' };
        return (_jsxs("div", { className: "ll_h_c", style: { fontSize: '0.9em', lineHeight: 1.25 }, children: [_jsx(ExpandCollapseComponentSVG, { ...this.props.node }), _jsxs("div", { className: "clickable", children: [_jsx("span", { style: nameStyle, children: "\"this.props.node.propKey\"" }), value !== '' ? ': ' : '', _jsx("span", { style: valueStyle(value), children: `${value}` })] })] }));
    }
}
export const Playground_Tree_Data = { name: 'Tree - Data', key: 'tree-data', renderer: Example_Tree_Data };
